import React, { useState } from 'react';
import './index.scss';
import {
  Bubble,
  Button,
  SelectMultiple,
  SelectOptionWithGroup,
} from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import country from '@/pages/home/_locales/en-US/country';
// changeValue: 选择的值
// optionsList: 数据的列表
// labelValue:     标签文字
// className:      类名
// getSelectMultiple: 获取选中的值
// listHeight:    列表高度
// searchable:   是否有搜索
// allOption:    是否全选
// disabled：是否禁用
// labelIcon:    标签图标
// total:        总条数
// groups:       分组
// countryIcon:  国家图标样式开启
// rowClassName: 每一行式
// array:        数组
const SelectMultipleChoice = (porps: any) => {
  const {
    changeValue,
    optionsList,
    labelValue,
    className,
    overlayClassName,
    getSelectMultiple,
    listHeight,
    searchable,
    allOption,
    disabled,
    labelIcon,
    total,
    groups,
    rowClassName,
    listWidth,
    ClearTips,
    ClearTipsDome,
    getClear,
    size,
    ShowDom,
    onClose = () => console.log,
    array
  } = porps;

  // console.log('SelectMultipleChoice',porps);

  const optionsChanage: any = [];
  optionsList.map((item: any) => {
    optionsChanage.push({
      ...item, //比如自带的tooltip,disabled配置不要丢失
      value: item.value,
      text: ShowDom ? (
        <ShowDom data={item} />
      ) : (
        <ItemShow rowClassName={rowClassName} data={item} />
      ),
      groupKey: item?.groupKey,
    });
  });
  return (
    <SelectMultiple
      className={`dbi-multiple-choice ${className}`}
      overlayClassName={overlayClassName}
      staging={false}
      matchButtonWidth={listWidth ? false : true}
      size={size ? size : 'm'}
      groups={groups ? groups : null}
      listHeight={listHeight ? listHeight : 400}
      listWidth={listWidth ? listWidth : false}
      style={{ width: listWidth }}
      appearance="button"
      allOption={allOption ? allOption : false}
      searchable={searchable ? true : false}
      disabled={disabled ? true : false}
      value={changeValue}
      onChange={(value) => getSelectMultiple(value)}
      onClose={onClose}
      options={optionsChanage}
      button={(option) => (
        <div className="dbi-select-button">
          {labelValue ? (
            <div className="dbi-select-button-text">
              {labelIcon ? (
                <img src={labelIcon} className="dbi-select-tipIcon" />
              ) : (
                ''
              )}
              {labelValue}
            </div>
          ) : (
            ''
          )}
          <div className="dbi-select-row">
            {total
              ? option.length + '/' + optionsChanage.length
              : optionsChanage.length == option.length
              ? 'all'
              : option.length > 1
              ? option.length
              : option.map((o, i) => (
                  <div className="dbi-select-change" key={i}>
                    {o.text}
                  </div>
                ))}
          </div>
        </div>
      )}
      searchPlaceholder="search"
      tips={
        ClearTips ? (
          <div className="dbi-tips-flex">
            {ClearTipsDome ? (
              ClearTipsDome
            ) : (
              <div className="dbi-tips-flex-left">{labelValue}</div>
            )}

            <Button
              type="link"
              onClick={() => getClear()}
              className="dbi-tips-flex-right"
            >
              Clear All
            </Button>
          </div>
        ) : (
          false
        )
      }
      {...array}
    />
  );
};

export default SelectMultipleChoice;

const ItemShow = (porps: any) => {
  let { data, rowClassName } = porps;
  return (
    <div className={`dbi-select-icon-show ${rowClassName}`}>
      <Bubble placement="top" dark content={data.text}>
        <>
          {data?.svg ? <img src={data.svg} className="dbi-select-icon" /> : ''}
          <span>{data.text}</span>
        </>
      </Bubble>
    </div>
  );
};
